import React, { useState, useEffect, useRef } from "react";
import "./Distances.css";
import { Link, useHistory } from "react-router-dom";
import { db } from "./firebase";
import { useStateValue } from "./StateProvider";
import { holes } from "./CourseInfoOld";

function DistancesLive() {
  const history = useHistory();
  const [{ user }] = useStateValue();
  const [{ hole }] = useStateValue();
  const [greenCoord, setGreenCoord] = useState();
  const [latitude, setLatitude] = useState();
  const [longitude, setLongitude] = useState();
  const [accuracy, setAccuracy] = useState();
  const [front, setFront] = useState();
  const [center, setCenter] = useState();
  const [back, setBack] = useState();
  // const [pin, setPin] = useState();
  const locationWatchId = useRef(null);
  const [touchStartY, setTouchStartY] = useState(0);
  const [touchEndY, setTouchEndY] = useState(0);

  useEffect(() => {
    setGreenCoord([]);
    setLatitude("");
    setLongitude("");
    setAccuracy("");
    setFront("");
    setBack("");
    setCenter("");
    getLocation();
    // Clear the location watch instance when React unmounts the used component
    return cancelLocationWatch;
  }, []);

  // Clears the watch instance based on the saved watch id
  const cancelLocationWatch = () => {
    if (locationWatchId.current && navigator.geolocation) {
      navigator.geolocation.clearWatch(locationWatchId.current);
    }
  };

  const getLocation = () => {
    if (navigator.geolocation) {
      //watchPosition to get more accuracy
      // let acc;
      locationWatchId.current = navigator.geolocation.watchPosition(
        (position) => {
          // acc = position.coords.accuracy.toFixed(2);
          setAccuracy(position.coords.accuracy.toFixed(2));
          setLatitude(position.coords.latitude.toFixed(13));
          setLongitude(position.coords.longitude.toFixed(13));
          getAllDistances(position.coords.latitude, position.coords.longitude);
        },
        (error) => {
          if (error.message == "Timeout expired") {
            alert("Limited Accuracy Acheivable");
          } else {
            alert(error.message);
          }
        },
        {
          enableHighAccuracy: true,
          timeout: 20000,
          maximumAge: 0,
          distanceFilter: 1,
        }
      );
    }
  };

  const getAllDistances = (lat, long) => {
    setFront(
      getDistanceFromLatLonInYds(
        lat,
        long,
        holes[hole].greenfront[0],
        holes[hole].greenfront[1]
      ).toFixed(0)
    );
    setCenter(
      getDistanceFromLatLonInYds(
        lat,
        long,
        holes[hole].greencenter[0],
        holes[hole].greencenter[1]
      ).toFixed(0)
    );
    setBack(
      getDistanceFromLatLonInYds(
        lat,
        long,
        holes[hole].greenback[0],
        holes[hole].greenback[1]
      ).toFixed(0)
    );
    // const Pin = greenCoord.find((c) => c.location === "pin");      If retreived from firebase
    // setPin(
    //   getDistanceFromLatLonInYds(lat, long, Pin.lat, Pin.long).toFixed(0)
    // );
  };

  const getDistanceFromLatLonInYds = (lat1, lon1, lat2, lon2) => {
    let R = 6975240.5949256; // Radius of the earth in yards
    let dLat = deg2rad(lat2 - lat1); // deg2rad below
    let dLon = deg2rad(lon2 - lon1);
    let a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) *
        Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    let d = R * c; // Distance in yards
    return d;
  };

  const deg2rad = (deg) => {
    return deg * (Math.PI / 180);
  };

  function handleTouchStart(e) {
    setTouchStartY(e.targetTouches[0].clientY);
  }

  function handleTouchMove(e) {
    setTouchEndY(e.targetTouches[0].clientY);
  }

  // console.log("TouchStart", touchStartY);
  // console.log("TouchMove", touchStartY - touchEndY);
  function handleTouchEnd() {
    // do your stuff here for up swipe
    touchStartY - touchEndY > 25 && history.push("/scoring");
  }

  return (
    <div
      className="finddistances"
      onTouchStart={(e) => handleTouchStart(e)}
      onTouchMove={(e) => handleTouchMove(e)}
      onTouchEnd={() => handleTouchEnd()}
    >
      <div className="holepage__topline">
        <div className="hole__number">
          <h1 className="hole__number">Hole #{hole}</h1>
        </div>
      </div>
      {/* {user.email==="docdatainc@gmail.com" && latitude && <div> {latitude}, {longitude}</div>} */}
      <div className="distances__container">
        <div className="table__container">
          <table className="dist_table">
            {/* <header className="green"> */}
            <tbody>
              <tr className="dist__labels">
                <th>Front</th>
                <th>Center</th>
                <th>Back</th>
                {/* <th>Pin</th> */}
              </tr>
              {/* </header> */}
              {/* <body> */}
              <tr className="distances">
                <td>{front}</td>
                <td>{center}</td>
                <td>{back}</td>
                {/* <td>{pin}</td> */}
              </tr>
              {/* </body> */}
            </tbody>
          </table>
        </div>
      </div>
      <div className="acc__container">
        {accuracy && (
          <div className="accuracy">
            <div>
              <span className="acc__title">Accuracy</span>
            </div>
            <div>
              <span className="acc">
                {" "}
                +/-{(accuracy * 1.0936133).toFixed(0)}{" "}
              </span>
            </div>
          </div>
        )}
      </div>
      <div className="loc__coords">
        <table>
          <tbody>
            <tr>
              <td>Your location</td>
              <td>
                {latitude}, {longitude}{" "}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default DistancesLive;
